// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./~/rc-upload/es/index.js
// module id = 1589
// module chunks = 3